export default __webpack_public_path__ + "static/media/i-copy.e5a72d2a.svg";